<template>
  <div class="test_paper">
    <div class="paper_top flex Flexalign FlexBetween mb-20">
      <div class="exercise-title">· 作答记录</div>
      <div class="flex Flexalign cursor_pointer" @click="practiceBack">
        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
        <div class="back_text">返回</div>
      </div>
    </div>
    <!-- <div class="homewor_score flex Flexalign">
      <div>总分：</div>
      <div class="questionScore ml-10">
        得分：{{ homeworkInfo.questionScore }}分
      </div>
    </div> -->
    <div class="homework_name mt-10">{{ homeworkInfo.examName }}</div>
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业描述</div>
    </div>
    <div class="homework_desc mt-15">{{ homeworkInfo.examDetail || homeworkInfo.homeworkDescription }}</div>
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业内容</div>
    </div>
    <div class="homework_desc mt-15" v-html="$Tools.handlerImg(homeworkInfo.assignmentContent || homeworkInfo.customHomeworkContent)"></div>
    <div class="homework_difficult flex Flexalign mt-20" v-if="homeworkInfo.assignmentFile?.length || homeworkInfo.customHomeworkFile?.length">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业附件</div>
    </div>
    <div class="homework_desc mt-15" v-if="homeworkInfo.assignmentFile?.length">
      <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.assignmentFile" :key="index"
        @click="openFile(item.url)">
        {{ item.name }}
      </div>
    </div>
    <div class="homework_desc mt-15" v-if="homeworkInfo.customHomeworkFile?.length">
      <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.customHomeworkFile" :key="index"
        @click="openFile(item.url)">
        {{ item.name }}
      </div>
    </div>
    <div class="split_line my-30"></div>
    <!-- 无答题卡 -->
    <div v-if="$Tools.empty(homeworkInfo.answerCard)">
      <div class="your_answer flex Flexalign">
        <div class="dot"></div>
        <div class="answer_label ml-10">你的回答</div>
      </div>
      <div class="homework_desc mt-15" v-html="$Tools.handlerImg(homeworkInfo.assignmentContentAnswer || homeworkInfo.customHomeworkContentAnswer)"></div>
      <!-- <div class="homework_desc mt-15">
        <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.assignmentFileAnswer" :key="index"
          @click="openFile(item.url)">
          {{ item.name }}
        </div>
      </div> -->
      <!-- <div class="homework_desc mt-15">
        <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.customHomeworkFileAnswer" :key="index"
          @click="openFile(item.url)">
          {{ item.name }}
        </div>
      </div> -->
    </div>
    <div v-else>
      <customAnswerSheet :type="1" :homeworkInfo="homeworkInfo" @goBack="practiceBack" ref="customAnswerSheet">
      </customAnswerSheet>
    </div>
    <!-- <div class="your_answer flex Flexalign mt-30">
      <div class="dot"></div>
      <div class="answer_label ml-10">老师点评</div>
    </div>
    <div class="homework_desc mt-15" v-html="$Tools.handlerImg(homeworkInfo.markerComment)"></div> -->
    <div class="homework_desc mt-15">
      <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.markFile" :key="index"
        @click="openFile(item.url)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import customAnswerSheet from "./customAnswerSheet.vue";
export default {
  name: "GjkcH5CustomeHomeworkRecord",
  components: {
    customAnswerSheet,
  },

  data() {
    return {
      homeworkInfo: {},
    };
  },

  mounted() { },

  methods: {
    practiceBack() {
      this.$emit("practiceBack", false, this.isHome, this.isChallenge);
    },
    getFileName(url) {
      return url.split("/").pop();
    },
    openFile(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.test_paper {
  .paper_top {
    .empty {
      width: 1px;
      height: 1px;
    }

    .exercise-title {
      font-size: 18px;
      font-weight: 600;
    }

    .count_down {
      // width: 170px;
      height: 36px;
      background: linear-gradient(-42deg, #f45f0a 1%, #ed752f 100%);
      box-shadow: 0px 0px 9px 0px rgba(254, 121, 47, 0.53),
        0px 3px 3px 0px rgba(255, 255, 255, 0.23);
      border-radius: 10px;
      color: #ffffff;
      padding: 0 20px;
      line-height: 36px;
      margin-left: 60px;
    }

    .back_icon {
      width: 28px;
      height: 28px;
    }

    .back_text {
      font-size: 14px;
      color: #13d6aa;
      margin-left: 7px;
    }
  }

  .homewor_score {
    background: #f9f9f9;
    border-radius: 17px;
    padding: 5px 15px;
    font-weight: 500;
    font-size: 12px;
    color: #111111;

    .questionScore {
      color: #fd673b;
    }
  }

  .homework_name {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #111111;
  }

  .homework_difficult {
    font-size: 12px;
    color: #999999;

    .line_green {
      width: 3px;
      height: 16px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 4px;
    }

    .difficult_text {
      font-size: 14px;
      color: #111111;
    }
  }

  .homework_desc {
    overflow-wrap: anywhere;
    font-size: 14px;
    color: #666660;
    line-height: 24px;

    .file_name {
      color: rgb(49, 49, 237);
      text-decoration: underline;
    }
  }

  .split_line {
    border: 1px dashed rgba(0, 0, 0, 0.1);
  }

  .your_answer {
    font-weight: 500;
    font-size: 14px;
    color: #13d6aa;
    line-height: 20px;

    .dot {
      width: 5px;
      height: 5px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 50%;
    }
  }
}
</style>
